import { Duration } from 'luxon';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class DeviceSleepTime extends LitEntity {
  static get properties() {
    return {
      desired: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.entity) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    const sleepSeconds = this.getProperty(`sleepSeconds.${this.desired ? 'desired' : 'reported'}`);
    if (!sleepSeconds) {
      return html`${this.desired ? 'default' : 'unknown'}`;
    }
    return html`${Duration.fromMillis(sleepSeconds * 1000).shiftTo('hours', 'minutes').toHuman()}`;
  }
}

window.customElements.define('device-sleep-time', DeviceSleepTime);
